import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import { DashboardCard, Statistic, Tag } from '@monorepo/nova-ui';
import { useDashboard } from '../../../../../contexts';

export const DailyProfitCard: FC = () => {
  const { accountBalance } = useDashboard();

  const { t } = useTranslation('keyMetrics');

  const dailyPnL = accountBalance?.dailyProfitAndLoss || 0;
  const currentBalance = accountBalance?.balance || 0;
  const isPositive = dailyPnL >= 0;

  const calculateDailyPercentage = () => {
    if (dailyPnL === 0) return '0.00%';

    const dailyStartBalance = currentBalance - dailyPnL;

    if (!dailyStartBalance || dailyStartBalance === 0) {
      return '0.00%';
    }

    const percentage = (dailyPnL / dailyStartBalance) * 100;
    return `${percentage.toFixed(2)}%`;
  };

  const percentageChange = calculateDailyPercentage();

  return (
    <DashboardCard
      sx={{
        justifyContent: 'space-between',
        minHeight: 100,
      }}
    >
      <Typography
        variant="body2"
        sx={(theme) => ({
          color: theme.palette.text.second,
          fontSize: theme.typography.pxToRem(14),
        })}
      >
        {t('cards.dailyProfit.title')}
      </Typography>
      <Stack
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        gap={1}
        sx={{
          width: '100%',
        }}
      >
        <Typography
          component="div"
          sx={(theme) => ({
            fontSize: theme.typography.pxToRem(24),
          })}
        >
          <Statistic
            value={Math.abs(dailyPnL).toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
            prefix={isPositive ? '$' : '-$'}
          />
        </Typography>
        <Tag
          label={percentageChange}
          color={isPositive ? 'success' : 'error'}
          size="small"
        />
      </Stack>
    </DashboardCard>
  );
};
